import React from 'react';
import styled from 'styled-components';

import { CanvasBox, CanvasContainer, CanvasItem, Media } from '@amzn/monera-app-core-components';

const BACKGROUND_GRAY = '#f4f6f6';
export const TopSkillWidgetContainer = styled((props) => <CanvasContainer {...props} />)`
  box-sizing: border-box;
  background-color: ${BACKGROUND_GRAY};
  flex-wrap: nowrap;
`;

export const Utterance = styled.a`
  flex-wrap: nowrap;
  display: flex;
  direction: row;
  align-items: center;
  box-sizing: border-box;
  background-color: white;
  flex-wrap: nowrap;
  width: 238px;
  height: 102px;
  border-radius: 6px;
  padding: 10px;
  border: 1px solid #eaeded;
  margin: 0 0 4px 0;
  &:hover {
    cursor: pointer;
  }
  text-decoration-line: none;
`;

export const StyledMedia = styled((props) => <Media {...props} />)`
  &:hover {
    cursor: pointer;
  }
`;

export const Title = styled((props) => <CanvasBox {...props} />)`
  box-sizing: border-box;
  background-color: ${BACKGROUND_GRAY};
  flex-wrap: nowrap;
  text-align: start;
`;

export const Reviews = styled.a`
  width: fit-content;
  &:hover {
    cursor: pointer;
  }
  background-color: ${BACKGROUND_GRAY};
  box-sizing: border-box;
  flex-wrap: nowrap;
  display: flex;
  flex-direction: row;
  padding: 4px 0 0 0;
  font-size: 12px;
  text-decoration-line: none;
`;

export const StarBox = styled((props) => <CanvasItem {...props} />)`
  width: fit-content;
`;
